import { Channel } from '@nemuru-eng/js-api-client';

import { ChannelTypeIcons } from '@/components/modules/MerchantDetail/MerchantStructure/constants/ChannelTypeIcons';
import { SelectItem } from '@/components/shared/components/AgentSelectionComponent/types/SelectItem';

export const ChannelMap = {
  toSelectItem: (channel: Channel): SelectItem => {
    return {
      id: channel.id,
      name: channel.description,
      icon: ChannelTypeIcons[channel.type] ?? 'storefront',
    };
  },
};
